import {z} from 'zod';

export const queueCountsErrorResponseSchema = z.object({
  status: z.string(),
  message: z.string(),
  timestamp: z.string(),
});
